/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldViewer} from "./BaseFieldViewer";
import autobind from "autobind-decorator";
import {
	service as SurveyQuestionSecondaryFieldRequiredService
} from "../../../Services/SurveyQuestionSecondaryFieldRequiredService";

export class SurveyQuestionSecondaryFieldRequiredFieldViewer extends BaseFieldViewer {
	constructor(props) {
		super(props);

		this.setInitialState({
			surveyQuestionSecondaryFieldRequireds: []
		});
	}

	@autobind
	shouldReloadData(prevProps, prevState) {
		return this.props.Value != prevProps.Value;
	}

	@autobind
	loadData() {
		super.loadData();

		SurveyQuestionSecondaryFieldRequiredService.Get()
			.then((x) => {
				this.setState({surveyQuestionSecondaryFieldRequireds: x.result});
			});
	}

	@autobind
	getSurveyQuestionSecondaryFieldRequired() {
		return this.state.surveyQuestionSecondaryFieldRequireds.find((x) => x.surveyQuestionSecondaryFieldRequiredId == this.props.Value);
	}

	@autobind
	_render() {
		return this.getSurveyQuestionSecondaryFieldRequired() ? this.getSurveyQuestionSecondaryFieldRequired().name : "N/A";
	}
}